// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.1
// source: events/so5/web/events.proto

/* eslint-disable */
import {
  Sport,
  sportFromJSON,
  sportToJSON,
} from '#src/protos/events/shared/events.ts';

export const protobufPackage = 'events.so5.web';

export interface CardInfo {
  cardSlug: string;
  scarcity: string;
  sport: Sport;
}

export interface BundledCardsInfo {
  cardSlugs: string[];
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  sport: Sport;
}

export interface ClickCard {
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface ClickBundle {
  auctionId: string;
  /** BundledCardsInfo */
  cardSlugs: string[];
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface ClickBid {
  auctionId: string;
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  count: number;
  ethAmount: number;
  eurAmount: number;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
  isV2?: boolean | undefined;
}

export interface ClickBundledBid {
  auctionId: string;
  /** BundledCardsInfo */
  cardSlugs: string[];
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  count: number;
  ethAmount: number;
  eurAmount: number;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface ClickBuy {
  offerId: string;
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  ethAmount: number;
  eurAmount: number;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface ClosePaymentBox {}

export interface CloseWallet {}

export interface ClickBackWallet {}

export interface ClickBanner {
  bannerId: string;
  tileIndex: number;
  bannerTitle: string;
  bannerType: string;
  bannerSlotName: string;
  sport: Sport;
}

export interface UseMarketFilter {
  filterName: string;
  filterValue: string;
  interactionContext: string;
  sport: Sport;
}

export interface FavoriteCard {
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  interactionContext: string;
  sport: Sport;
}

export interface FollowPlayer {
  playerSlug: string;
  position: string;
  positions: string[];
  teamSlug: string;
  alertLimited: boolean;
  alertRare: boolean;
  alertSuperRare: boolean;
  alertUnique: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface PlaceBid {
  auctionId: string;
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  secondary: boolean;
  sport: Sport;
}

export interface PlaceBundledBid {
  auctionId: string;
  /** BundledCardsInfo */
  cardSlugs: string[];
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  secondary: boolean;
  sport: Sport;
}

export interface ToggleHideBalance {
  hidden: boolean;
}

export interface SeeTCUModal {
  mobile: boolean;
}

export interface AcceptTCU {
  source: string;
}

export interface AttemptToSignupFromSanctionedCountry {
  countryCode: string;
}

export interface SignUpForProductUpdates {
  email: string;
  topic: string;
}

export interface UseThirdParty {
  name: string;
}

export interface ClickInviteFriends {
  source: string;
}

export interface DisplayWarningHighBidAmount {
  auctionId: string;
  cardSlugs: string[];
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  multiplier: number;
  sport: Sport;
}

export interface DisplayWarningVeryHighBidAmount {
  auctionId: string;
  cardSlugs: string[];
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  multiplier: number;
  sport: Sport;
}

export interface PlaceBidAfterDisplayWarningHighBidAmount {
  auctionId: string;
  cardSlugs: string[];
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  multiplier: number;
  sport: Sport;
}

export interface PlaceBidAfterDisplayWarningVeryHighBidAmount {
  auctionId: string;
  cardSlugs: string[];
  count: number;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  multiplier: number;
  sport: Sport;
}

export interface ClickFilterInSearch {
  sport: Sport;
  context: Sport;
  searchTerm: string;
}

export interface ClickSearchResult {
  sport: Sport;
  context: Sport;
  searchTerm: string;
  resultCategory: string;
  resultDestination: string;
}

export interface ExitSearchWithoutClickingResult {
  sport: Sport;
  context: Sport;
  searchTerm: string;
}

export interface WalletOpened {
  interactionContext: string;
  sport: Sport;
}

export interface ListCard {
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  ethAmount: number;
  eurAmount: number;
  duration: number;
  sport: Sport;
}

export interface UnlistCard {
  /** CardInfo */
  cardSlug: string;
  scarcity: string;
  unlistingType: string;
  listingTime: number;
  cancelledBy: string;
  sport: Sport;
}

export interface ClickPlayNow {
  interactionContext: string;
  sport: Sport;
}

export interface ClickSignUp {
  interactionContext: string;
  variation: string;
  forceEmailConfirmation?: boolean | undefined;
}

export interface ViewSignUpModal {
  interactionContext: string;
  variation: string;
}

export interface ClickOauthSignUp {
  method: ClickOauthSignUp_Method;
}

export enum ClickOauthSignUp_Method {
  GOOGLE = 0,
  FACEBOOK = 1,
  APPLE = 2,
  UNRECOGNIZED = -1,
}

export function clickOauthSignUp_MethodFromJSON(
  object: any
): ClickOauthSignUp_Method {
  switch (object) {
    case 0:
    case 'GOOGLE':
      return ClickOauthSignUp_Method.GOOGLE;
    case 1:
    case 'FACEBOOK':
      return ClickOauthSignUp_Method.FACEBOOK;
    case 2:
    case 'APPLE':
      return ClickOauthSignUp_Method.APPLE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickOauthSignUp_Method.UNRECOGNIZED;
  }
}

export function clickOauthSignUp_MethodToJSON(
  object: ClickOauthSignUp_Method
): string {
  switch (object) {
    case ClickOauthSignUp_Method.GOOGLE:
      return 'GOOGLE';
    case ClickOauthSignUp_Method.FACEBOOK:
      return 'FACEBOOK';
    case ClickOauthSignUp_Method.APPLE:
      return 'APPLE';
    case ClickOauthSignUp_Method.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickPriceHistory {
  interactionContext: string;
  cardSlug: string;
  clickedCardSlug: string;
}

export interface ExpandPriceHistory {
  interactionContext: string;
  cardSlug: string;
}

export interface ClickBundledBuy {
  offerId: string;
  cardSlugs: string[];
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  ethAmount: number;
  eurAmount: number;
  secondary: boolean;
  interactionContext: string;
  sport: Sport;
}

export interface ClickSetLineup {
  so5LeaderboardSlug: string;
  trigger: string;
  interactionContext: string;
  sport: Sport;
}

export interface OpenFixtureOverview {
  so5FixtureSlug: string;
  so5FixtureState: string;
  interactionContext: string;
  sport: Sport;
}

export interface ShareDuoMission {
  interactionContext: string;
  sport: Sport;
}

export interface ToggleCanBeatMe {
  canBeatMe: boolean;
}

export interface ViewMyCirclesScreen {}

export interface ViewMyCirclesUserProfileScreen {}

export interface ClickLineupDetailsMyCircle {}

export interface ClickMyCirclesDatePicker {}

export const CardInfo: MessageFns<CardInfo> = {
  fromJSON(object: any): CardInfo {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: CardInfo): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const BundledCardsInfo: MessageFns<BundledCardsInfo> = {
  fromJSON(object: any): BundledCardsInfo {
    return {
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: BundledCardsInfo): unknown {
    const obj: any = {};
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickCard: MessageFns<ClickCard> = {
  fromJSON(object: any): ClickCard {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickCard): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickBundle: MessageFns<ClickBundle> = {
  fromJSON(object: any): ClickBundle {
    return {
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBundle): unknown {
    const obj: any = {};
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickBid: MessageFns<ClickBid> = {
  fromJSON(object: any): ClickBid {
    return {
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      isV2: isSet(object.is_v2) ? globalThis.Boolean(object.is_v2) : undefined,
    };
  },

  toJSON(message: ClickBid): unknown {
    const obj: any = {};
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.count !== undefined) {
      obj.count = Math.round(message.count);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.isV2 !== undefined) {
      obj.is_v2 = message.isV2;
    }
    return obj;
  },
};

export const ClickBundledBid: MessageFns<ClickBundledBid> = {
  fromJSON(object: any): ClickBundledBid {
    return {
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBundledBid): unknown {
    const obj: any = {};
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.count !== undefined) {
      obj.count = Math.round(message.count);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickBuy: MessageFns<ClickBuy> = {
  fromJSON(object: any): ClickBuy {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBuy): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClosePaymentBox: MessageFns<ClosePaymentBox> = {
  fromJSON(_: any): ClosePaymentBox {
    return {};
  },

  toJSON(_: ClosePaymentBox): unknown {
    const obj: any = {};
    return obj;
  },
};

export const CloseWallet: MessageFns<CloseWallet> = {
  fromJSON(_: any): CloseWallet {
    return {};
  },

  toJSON(_: CloseWallet): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickBackWallet: MessageFns<ClickBackWallet> = {
  fromJSON(_: any): ClickBackWallet {
    return {};
  },

  toJSON(_: ClickBackWallet): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickBanner: MessageFns<ClickBanner> = {
  fromJSON(object: any): ClickBanner {
    return {
      bannerId: isSet(object.banner_id)
        ? globalThis.String(object.banner_id)
        : '',
      tileIndex: isSet(object.tile_index)
        ? globalThis.Number(object.tile_index)
        : 0,
      bannerTitle: isSet(object.banner_title)
        ? globalThis.String(object.banner_title)
        : '',
      bannerType: isSet(object.banner_type)
        ? globalThis.String(object.banner_type)
        : '',
      bannerSlotName: isSet(object.banner_slot_name)
        ? globalThis.String(object.banner_slot_name)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBanner): unknown {
    const obj: any = {};
    if (message.bannerId !== undefined) {
      obj.banner_id = message.bannerId;
    }
    if (message.tileIndex !== undefined) {
      obj.tile_index = Math.round(message.tileIndex);
    }
    if (message.bannerTitle !== undefined) {
      obj.banner_title = message.bannerTitle;
    }
    if (message.bannerType !== undefined) {
      obj.banner_type = message.bannerType;
    }
    if (message.bannerSlotName !== undefined) {
      obj.banner_slot_name = message.bannerSlotName;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const UseMarketFilter: MessageFns<UseMarketFilter> = {
  fromJSON(object: any): UseMarketFilter {
    return {
      filterName: isSet(object.filter_name)
        ? globalThis.String(object.filter_name)
        : '',
      filterValue: isSet(object.filter_value)
        ? globalThis.String(object.filter_value)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: UseMarketFilter): unknown {
    const obj: any = {};
    if (message.filterName !== undefined) {
      obj.filter_name = message.filterName;
    }
    if (message.filterValue !== undefined) {
      obj.filter_value = message.filterValue;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const FavoriteCard: MessageFns<FavoriteCard> = {
  fromJSON(object: any): FavoriteCard {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: FavoriteCard): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const FollowPlayer: MessageFns<FollowPlayer> = {
  fromJSON(object: any): FollowPlayer {
    return {
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
      position: isSet(object.position)
        ? globalThis.String(object.position)
        : '',
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => globalThis.String(e))
        : [],
      teamSlug: isSet(object.team_slug)
        ? globalThis.String(object.team_slug)
        : '',
      alertLimited: isSet(object.alert_limited)
        ? globalThis.Boolean(object.alert_limited)
        : false,
      alertRare: isSet(object.alert_rare)
        ? globalThis.Boolean(object.alert_rare)
        : false,
      alertSuperRare: isSet(object.alert_super_rare)
        ? globalThis.Boolean(object.alert_super_rare)
        : false,
      alertUnique: isSet(object.alert_unique)
        ? globalThis.Boolean(object.alert_unique)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: FollowPlayer): unknown {
    const obj: any = {};
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.position !== undefined) {
      obj.position = message.position;
    }
    if (message.positions?.length) {
      obj.positions = message.positions;
    }
    if (message.teamSlug !== undefined) {
      obj.team_slug = message.teamSlug;
    }
    if (message.alertLimited !== undefined) {
      obj.alert_limited = message.alertLimited;
    }
    if (message.alertRare !== undefined) {
      obj.alert_rare = message.alertRare;
    }
    if (message.alertSuperRare !== undefined) {
      obj.alert_super_rare = message.alertSuperRare;
    }
    if (message.alertUnique !== undefined) {
      obj.alert_unique = message.alertUnique;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const PlaceBid: MessageFns<PlaceBid> = {
  fromJSON(object: any): PlaceBid {
    return {
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      fiatPayment: isSet(object.fiat_payment)
        ? globalThis.Boolean(object.fiat_payment)
        : false,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: PlaceBid): unknown {
    const obj: any = {};
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.count !== undefined) {
      obj.count = Math.round(message.count);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.fiatPayment !== undefined) {
      obj.fiat_payment = message.fiatPayment;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const PlaceBundledBid: MessageFns<PlaceBundledBid> = {
  fromJSON(object: any): PlaceBundledBid {
    return {
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      fiatPayment: isSet(object.fiat_payment)
        ? globalThis.Boolean(object.fiat_payment)
        : false,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: PlaceBundledBid): unknown {
    const obj: any = {};
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.count !== undefined) {
      obj.count = Math.round(message.count);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.fiatPayment !== undefined) {
      obj.fiat_payment = message.fiatPayment;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ToggleHideBalance: MessageFns<ToggleHideBalance> = {
  fromJSON(object: any): ToggleHideBalance {
    return {
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
    };
  },

  toJSON(message: ToggleHideBalance): unknown {
    const obj: any = {};
    if (message.hidden !== undefined) {
      obj.hidden = message.hidden;
    }
    return obj;
  },
};

export const SeeTCUModal: MessageFns<SeeTCUModal> = {
  fromJSON(object: any): SeeTCUModal {
    return {
      mobile: isSet(object.mobile) ? globalThis.Boolean(object.mobile) : false,
    };
  },

  toJSON(message: SeeTCUModal): unknown {
    const obj: any = {};
    if (message.mobile !== undefined) {
      obj.mobile = message.mobile;
    }
    return obj;
  },
};

export const AcceptTCU: MessageFns<AcceptTCU> = {
  fromJSON(object: any): AcceptTCU {
    return {
      source: isSet(object.source) ? globalThis.String(object.source) : '',
    };
  },

  toJSON(message: AcceptTCU): unknown {
    const obj: any = {};
    if (message.source !== undefined) {
      obj.source = message.source;
    }
    return obj;
  },
};

export const AttemptToSignupFromSanctionedCountry: MessageFns<AttemptToSignupFromSanctionedCountry> =
  {
    fromJSON(object: any): AttemptToSignupFromSanctionedCountry {
      return {
        countryCode: isSet(object.country_code)
          ? globalThis.String(object.country_code)
          : '',
      };
    },

    toJSON(message: AttemptToSignupFromSanctionedCountry): unknown {
      const obj: any = {};
      if (message.countryCode !== undefined) {
        obj.country_code = message.countryCode;
      }
      return obj;
    },
  };

export const SignUpForProductUpdates: MessageFns<SignUpForProductUpdates> = {
  fromJSON(object: any): SignUpForProductUpdates {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      topic: isSet(object.topic) ? globalThis.String(object.topic) : '',
    };
  },

  toJSON(message: SignUpForProductUpdates): unknown {
    const obj: any = {};
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.topic !== undefined) {
      obj.topic = message.topic;
    }
    return obj;
  },
};

export const UseThirdParty: MessageFns<UseThirdParty> = {
  fromJSON(object: any): UseThirdParty {
    return { name: isSet(object.name) ? globalThis.String(object.name) : '' };
  },

  toJSON(message: UseThirdParty): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },
};

export const ClickInviteFriends: MessageFns<ClickInviteFriends> = {
  fromJSON(object: any): ClickInviteFriends {
    return {
      source: isSet(object.source) ? globalThis.String(object.source) : '',
    };
  },

  toJSON(message: ClickInviteFriends): unknown {
    const obj: any = {};
    if (message.source !== undefined) {
      obj.source = message.source;
    }
    return obj;
  },
};

export const DisplayWarningHighBidAmount: MessageFns<DisplayWarningHighBidAmount> =
  {
    fromJSON(object: any): DisplayWarningHighBidAmount {
      return {
        auctionId: isSet(object.auction_id)
          ? globalThis.String(object.auction_id)
          : '',
        cardSlugs: globalThis.Array.isArray(object?.card_slugs)
          ? object.card_slugs.map((e: any) => globalThis.String(e))
          : [],
        count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        ethAmount: isSet(object.eth_amount)
          ? globalThis.Number(object.eth_amount)
          : 0,
        eurAmount: isSet(object.eur_amount)
          ? globalThis.Number(object.eur_amount)
          : 0,
        fiatPayment: isSet(object.fiat_payment)
          ? globalThis.Boolean(object.fiat_payment)
          : false,
        multiplier: isSet(object.multiplier)
          ? globalThis.Number(object.multiplier)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: DisplayWarningHighBidAmount): unknown {
      const obj: any = {};
      if (message.auctionId !== undefined) {
        obj.auction_id = message.auctionId;
      }
      if (message.cardSlugs?.length) {
        obj.card_slugs = message.cardSlugs;
      }
      if (message.count !== undefined) {
        obj.count = Math.round(message.count);
      }
      if (message.ethAmount !== undefined) {
        obj.eth_amount = message.ethAmount;
      }
      if (message.eurAmount !== undefined) {
        obj.eur_amount = message.eurAmount;
      }
      if (message.fiatPayment !== undefined) {
        obj.fiat_payment = message.fiatPayment;
      }
      if (message.multiplier !== undefined) {
        obj.multiplier = message.multiplier;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const DisplayWarningVeryHighBidAmount: MessageFns<DisplayWarningVeryHighBidAmount> =
  {
    fromJSON(object: any): DisplayWarningVeryHighBidAmount {
      return {
        auctionId: isSet(object.auction_id)
          ? globalThis.String(object.auction_id)
          : '',
        cardSlugs: globalThis.Array.isArray(object?.card_slugs)
          ? object.card_slugs.map((e: any) => globalThis.String(e))
          : [],
        count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        ethAmount: isSet(object.eth_amount)
          ? globalThis.Number(object.eth_amount)
          : 0,
        eurAmount: isSet(object.eur_amount)
          ? globalThis.Number(object.eur_amount)
          : 0,
        fiatPayment: isSet(object.fiat_payment)
          ? globalThis.Boolean(object.fiat_payment)
          : false,
        multiplier: isSet(object.multiplier)
          ? globalThis.Number(object.multiplier)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: DisplayWarningVeryHighBidAmount): unknown {
      const obj: any = {};
      if (message.auctionId !== undefined) {
        obj.auction_id = message.auctionId;
      }
      if (message.cardSlugs?.length) {
        obj.card_slugs = message.cardSlugs;
      }
      if (message.count !== undefined) {
        obj.count = Math.round(message.count);
      }
      if (message.ethAmount !== undefined) {
        obj.eth_amount = message.ethAmount;
      }
      if (message.eurAmount !== undefined) {
        obj.eur_amount = message.eurAmount;
      }
      if (message.fiatPayment !== undefined) {
        obj.fiat_payment = message.fiatPayment;
      }
      if (message.multiplier !== undefined) {
        obj.multiplier = message.multiplier;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const PlaceBidAfterDisplayWarningHighBidAmount: MessageFns<PlaceBidAfterDisplayWarningHighBidAmount> =
  {
    fromJSON(object: any): PlaceBidAfterDisplayWarningHighBidAmount {
      return {
        auctionId: isSet(object.auction_id)
          ? globalThis.String(object.auction_id)
          : '',
        cardSlugs: globalThis.Array.isArray(object?.card_slugs)
          ? object.card_slugs.map((e: any) => globalThis.String(e))
          : [],
        count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        ethAmount: isSet(object.eth_amount)
          ? globalThis.Number(object.eth_amount)
          : 0,
        eurAmount: isSet(object.eur_amount)
          ? globalThis.Number(object.eur_amount)
          : 0,
        fiatPayment: isSet(object.fiat_payment)
          ? globalThis.Boolean(object.fiat_payment)
          : false,
        multiplier: isSet(object.multiplier)
          ? globalThis.Number(object.multiplier)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: PlaceBidAfterDisplayWarningHighBidAmount): unknown {
      const obj: any = {};
      if (message.auctionId !== undefined) {
        obj.auction_id = message.auctionId;
      }
      if (message.cardSlugs?.length) {
        obj.card_slugs = message.cardSlugs;
      }
      if (message.count !== undefined) {
        obj.count = Math.round(message.count);
      }
      if (message.ethAmount !== undefined) {
        obj.eth_amount = message.ethAmount;
      }
      if (message.eurAmount !== undefined) {
        obj.eur_amount = message.eurAmount;
      }
      if (message.fiatPayment !== undefined) {
        obj.fiat_payment = message.fiatPayment;
      }
      if (message.multiplier !== undefined) {
        obj.multiplier = message.multiplier;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const PlaceBidAfterDisplayWarningVeryHighBidAmount: MessageFns<PlaceBidAfterDisplayWarningVeryHighBidAmount> =
  {
    fromJSON(object: any): PlaceBidAfterDisplayWarningVeryHighBidAmount {
      return {
        auctionId: isSet(object.auction_id)
          ? globalThis.String(object.auction_id)
          : '',
        cardSlugs: globalThis.Array.isArray(object?.card_slugs)
          ? object.card_slugs.map((e: any) => globalThis.String(e))
          : [],
        count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        ethAmount: isSet(object.eth_amount)
          ? globalThis.Number(object.eth_amount)
          : 0,
        eurAmount: isSet(object.eur_amount)
          ? globalThis.Number(object.eur_amount)
          : 0,
        fiatPayment: isSet(object.fiat_payment)
          ? globalThis.Boolean(object.fiat_payment)
          : false,
        multiplier: isSet(object.multiplier)
          ? globalThis.Number(object.multiplier)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: PlaceBidAfterDisplayWarningVeryHighBidAmount): unknown {
      const obj: any = {};
      if (message.auctionId !== undefined) {
        obj.auction_id = message.auctionId;
      }
      if (message.cardSlugs?.length) {
        obj.card_slugs = message.cardSlugs;
      }
      if (message.count !== undefined) {
        obj.count = Math.round(message.count);
      }
      if (message.ethAmount !== undefined) {
        obj.eth_amount = message.ethAmount;
      }
      if (message.eurAmount !== undefined) {
        obj.eur_amount = message.eurAmount;
      }
      if (message.fiatPayment !== undefined) {
        obj.fiat_payment = message.fiatPayment;
      }
      if (message.multiplier !== undefined) {
        obj.multiplier = message.multiplier;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ClickFilterInSearch: MessageFns<ClickFilterInSearch> = {
  fromJSON(object: any): ClickFilterInSearch {
    return {
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      context: isSet(object.context) ? sportFromJSON(object.context) : 0,
      searchTerm: isSet(object.search_term)
        ? globalThis.String(object.search_term)
        : '',
    };
  },

  toJSON(message: ClickFilterInSearch): unknown {
    const obj: any = {};
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.context !== undefined) {
      obj.context = sportToJSON(message.context);
    }
    if (message.searchTerm !== undefined) {
      obj.search_term = message.searchTerm;
    }
    return obj;
  },
};

export const ClickSearchResult: MessageFns<ClickSearchResult> = {
  fromJSON(object: any): ClickSearchResult {
    return {
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      context: isSet(object.context) ? sportFromJSON(object.context) : 0,
      searchTerm: isSet(object.search_term)
        ? globalThis.String(object.search_term)
        : '',
      resultCategory: isSet(object.result_category)
        ? globalThis.String(object.result_category)
        : '',
      resultDestination: isSet(object.result_destination)
        ? globalThis.String(object.result_destination)
        : '',
    };
  },

  toJSON(message: ClickSearchResult): unknown {
    const obj: any = {};
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.context !== undefined) {
      obj.context = sportToJSON(message.context);
    }
    if (message.searchTerm !== undefined) {
      obj.search_term = message.searchTerm;
    }
    if (message.resultCategory !== undefined) {
      obj.result_category = message.resultCategory;
    }
    if (message.resultDestination !== undefined) {
      obj.result_destination = message.resultDestination;
    }
    return obj;
  },
};

export const ExitSearchWithoutClickingResult: MessageFns<ExitSearchWithoutClickingResult> =
  {
    fromJSON(object: any): ExitSearchWithoutClickingResult {
      return {
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
        context: isSet(object.context) ? sportFromJSON(object.context) : 0,
        searchTerm: isSet(object.search_term)
          ? globalThis.String(object.search_term)
          : '',
      };
    },

    toJSON(message: ExitSearchWithoutClickingResult): unknown {
      const obj: any = {};
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      if (message.context !== undefined) {
        obj.context = sportToJSON(message.context);
      }
      if (message.searchTerm !== undefined) {
        obj.search_term = message.searchTerm;
      }
      return obj;
    },
  };

export const WalletOpened: MessageFns<WalletOpened> = {
  fromJSON(object: any): WalletOpened {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: WalletOpened): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ListCard: MessageFns<ListCard> = {
  fromJSON(object: any): ListCard {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ListCard): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.duration !== undefined) {
      obj.duration = Math.round(message.duration);
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const UnlistCard: MessageFns<UnlistCard> = {
  fromJSON(object: any): UnlistCard {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      unlistingType: isSet(object.unlisting_type)
        ? globalThis.String(object.unlisting_type)
        : '',
      listingTime: isSet(object.listing_time)
        ? globalThis.Number(object.listing_time)
        : 0,
      cancelledBy: isSet(object.cancelled_by)
        ? globalThis.String(object.cancelled_by)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: UnlistCard): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.unlistingType !== undefined) {
      obj.unlisting_type = message.unlistingType;
    }
    if (message.listingTime !== undefined) {
      obj.listing_time = Math.round(message.listingTime);
    }
    if (message.cancelledBy !== undefined) {
      obj.cancelled_by = message.cancelledBy;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickPlayNow: MessageFns<ClickPlayNow> = {
  fromJSON(object: any): ClickPlayNow {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickPlayNow): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickSignUp: MessageFns<ClickSignUp> = {
  fromJSON(object: any): ClickSignUp {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      variation: isSet(object.variation)
        ? globalThis.String(object.variation)
        : '',
      forceEmailConfirmation: isSet(object.force_email_confirmation)
        ? globalThis.Boolean(object.force_email_confirmation)
        : undefined,
    };
  },

  toJSON(message: ClickSignUp): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.variation !== undefined) {
      obj.variation = message.variation;
    }
    if (message.forceEmailConfirmation !== undefined) {
      obj.force_email_confirmation = message.forceEmailConfirmation;
    }
    return obj;
  },
};

export const ViewSignUpModal: MessageFns<ViewSignUpModal> = {
  fromJSON(object: any): ViewSignUpModal {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      variation: isSet(object.variation)
        ? globalThis.String(object.variation)
        : '',
    };
  },

  toJSON(message: ViewSignUpModal): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.variation !== undefined) {
      obj.variation = message.variation;
    }
    return obj;
  },
};

export const ClickOauthSignUp: MessageFns<ClickOauthSignUp> = {
  fromJSON(object: any): ClickOauthSignUp {
    return {
      method: isSet(object.method)
        ? clickOauthSignUp_MethodFromJSON(object.method)
        : 0,
    };
  },

  toJSON(message: ClickOauthSignUp): unknown {
    const obj: any = {};
    if (message.method !== undefined) {
      obj.method = clickOauthSignUp_MethodToJSON(message.method);
    }
    return obj;
  },
};

export const ClickPriceHistory: MessageFns<ClickPriceHistory> = {
  fromJSON(object: any): ClickPriceHistory {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      clickedCardSlug: isSet(object.clicked_card_slug)
        ? globalThis.String(object.clicked_card_slug)
        : '',
    };
  },

  toJSON(message: ClickPriceHistory): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.clickedCardSlug !== undefined) {
      obj.clicked_card_slug = message.clickedCardSlug;
    }
    return obj;
  },
};

export const ExpandPriceHistory: MessageFns<ExpandPriceHistory> = {
  fromJSON(object: any): ExpandPriceHistory {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
    };
  },

  toJSON(message: ExpandPriceHistory): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    return obj;
  },
};

export const ClickBundledBuy: MessageFns<ClickBundledBuy> = {
  fromJSON(object: any): ClickBundledBuy {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBundledBuy): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = Math.round(message.ethAmount);
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = Math.round(message.eurAmount);
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickSetLineup: MessageFns<ClickSetLineup> = {
  fromJSON(object: any): ClickSetLineup {
    return {
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      trigger: isSet(object.trigger) ? globalThis.String(object.trigger) : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickSetLineup): unknown {
    const obj: any = {};
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.trigger !== undefined) {
      obj.trigger = message.trigger;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const OpenFixtureOverview: MessageFns<OpenFixtureOverview> = {
  fromJSON(object: any): OpenFixtureOverview {
    return {
      so5FixtureSlug: isSet(object.so5_fixture_slug)
        ? globalThis.String(object.so5_fixture_slug)
        : '',
      so5FixtureState: isSet(object.so5_fixture_state)
        ? globalThis.String(object.so5_fixture_state)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: OpenFixtureOverview): unknown {
    const obj: any = {};
    if (message.so5FixtureSlug !== undefined) {
      obj.so5_fixture_slug = message.so5FixtureSlug;
    }
    if (message.so5FixtureState !== undefined) {
      obj.so5_fixture_state = message.so5FixtureState;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ShareDuoMission: MessageFns<ShareDuoMission> = {
  fromJSON(object: any): ShareDuoMission {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ShareDuoMission): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ToggleCanBeatMe: MessageFns<ToggleCanBeatMe> = {
  fromJSON(object: any): ToggleCanBeatMe {
    return {
      canBeatMe: isSet(object.can_beat_me)
        ? globalThis.Boolean(object.can_beat_me)
        : false,
    };
  },

  toJSON(message: ToggleCanBeatMe): unknown {
    const obj: any = {};
    if (message.canBeatMe !== undefined) {
      obj.can_beat_me = message.canBeatMe;
    }
    return obj;
  },
};

export const ViewMyCirclesScreen: MessageFns<ViewMyCirclesScreen> = {
  fromJSON(_: any): ViewMyCirclesScreen {
    return {};
  },

  toJSON(_: ViewMyCirclesScreen): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ViewMyCirclesUserProfileScreen: MessageFns<ViewMyCirclesUserProfileScreen> =
  {
    fromJSON(_: any): ViewMyCirclesUserProfileScreen {
      return {};
    },

    toJSON(_: ViewMyCirclesUserProfileScreen): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickLineupDetailsMyCircle: MessageFns<ClickLineupDetailsMyCircle> =
  {
    fromJSON(_: any): ClickLineupDetailsMyCircle {
      return {};
    },

    toJSON(_: ClickLineupDetailsMyCircle): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickMyCirclesDatePicker: MessageFns<ClickMyCirclesDatePicker> = {
  fromJSON(_: any): ClickMyCirclesDatePicker {
    return {};
  },

  toJSON(_: ClickMyCirclesDatePicker): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
